<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 724.28 576">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <polygon class="cls-1" points="360.5 13.5 13.5 175.96 356.5 340.5 710.78 177 360.5 13.5" />
        <polyline class="cls-1" points="360.5 176.58 65.98 201.66 65.98 346.5" />
        <circle class="cls-1" cx="62.5" cy="386.5" r="40" />
        <polygon class="cls-1" points="62.5 434.3 43.5 562.5 83.87 562.5 62.5 434.3" />
        <path class="cls-1" d="M128.5,430.5,128,232.6" />
        <line class="cls-1" x1="593.99" y1="232.6" x2="593.99" y2="434.5" />
        <path class="cls-1" d="M593.5,427c0,44.46-104.09,80.5-232.5,80.5s-232.5-36-232.5-80.5" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TheAcademyCapIcon',
};
</script>

<style scoped>
.cls-1 {
  fill: none;
  stroke: #1a1a1a;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 27px;
}
</style>
